import { createContext, useContext } from 'react';

export interface EdgeActions {
  onDelete: (edgeId: string) => void;
  onToggleLock: (edgeId: string) => void;
  onBringToFront: (edgeId: string) => void;
  onSendToBack: (edgeId: string) => void;
  onBringForward: (edgeId: string) => void;
  onSendBackward: (edgeId: string) => void;
}

export const EdgeActionsContext = createContext<EdgeActions | null>(null);

export function useEdgeActions(): EdgeActions | null {
  return useContext(EdgeActionsContext);
}
